<div class="client-additional-info-request-list">
    <ol>
        <ng-container *ngFor="let typeNameAndDescription of this.typeNameAndDescriptionList">
            <div kendoTooltip filter=".name-wrapper" [tooltipWidth]="400" position="right">
                <div class="name-wrapper" [title]="typeNameAndDescription.description">
                    <li>
                        {{ typeNameAndDescription.name }}
                    </li>
                </div>
            </div>
        </ng-container>
    </ol> 
</div>
